/*
 * Date: 2025
 * Description: Reusable Footer can be formated on a specific way
 * Author: Philippe Leroux @ skitsc
 */
 
import { Typography , Box , Grid } from "@mui/material"
import { useContext } from "react";

//Context
import { ThemeContext } from "../../context/context";

const Footer = () => {
    const getCurrentYear = ()  => {
        const currentDate = new Date();
        return currentDate.getFullYear();
    }
    const { mode } = useContext(ThemeContext)
    const footerStyle = { bottom: 0, height : '40px' , alignContent : 'center', borderTop : '1px solid #D3D3D3' ,backgroundColor: mode === 'Light' ? "white" : "#222", }
    return (
        <Box sx={footerStyle}>
            <Grid container sx={{ width : '100%'}}>
                    <Grid size={{ xs: 12 }}>
                        <Grid container >
                            <Grid size={{ xs:12 }}>
                                <Box sx={{ display : 'flex' , justifyContent : 'center' }}>
                                    <Typography variant="body2" sx={{ textAlign : 'center' , marginRight : '6px'}}>{"© " + getCurrentYear() + " Xykal"}</Typography>
                                    <Typography variant="body2" sx={{ textAlign : 'center', marginRight : '6px'}}>All rights reserved.</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
            </Grid>
        </Box>
    )
}

export default Footer